import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "tab-header" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { class: "tab-content" }
const _hoisted_8 = { class: "flex justify-center" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import store from "@/store";

import { toast } from "@/common/utils/toast";

import { avatarAdd, avatarPut, avatarDel } from "@/common/api/rest/avatar";
import { consoleGet, consolePatch } from "@/common/api/rest/console/console";

import type { ConsoleType } from "@/common/types/console/console";
import type { TranslationFieldsType } from "@/common/types/translation";

import { FormConsole, ListTranslate } from "@/components";

import {
  baseAvatar,
  baseConfirm,
  breadcrumbSimple,
  iconMenu,
  svgIcon,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'infos',
  emits: ["update:data"],
  setup(__props, { emit: __emit }) {

const { t, locale } = useI18n();
const route = useRoute();
const router = useRouter();

const emit = __emit;

const consoleData = ref<ConsoleType | null>(null);

const showAvatarDel = ref(false);

const translationFields = ref<TranslationFieldsType[]>([
  {
    type: "input",
    field: "name",
    label: "common.labels.name",
    value: "",
  },
  {
    type: "textarea",
    field: "description",
    label: "common.labels.description",
    value: "",
  },
]);

const consoleId = computed(() => route.params.item as string);

const breadcrumbList = computed(() => [
  {
    key: "collections",
    label: t("common.labels.collections"),
    url: `/collection`,
  },
  {
    key: "collection",
    label: t("collection.labels.consoles"),
    url: `/collection/console`,
  },
  {
    key: "edit",
    label: consoleData.value?.name ?? "...",
  },
]);

const menuList = computed(() => [
  {
    key: "infos",
    icon: "field",
    label: t("collection.labels.infos"),
    url: `/collection/console/${consoleId.value}/infos`,
  },
  {
    key: "gallery",
    icon: "no-image",
    label: t("collection.labels.images"),
    url: `/collection/console/${consoleId.value}/gallery`,
  },
  // {
  //   key: "slug",
  //   icon: "no-image",
  //   label: t("collection.labels.slugs"),
  //   url: `/collection/console/${consoleId.value}/slug`,
  // },
  {
    key: "details",
    icon: "no-image",
    label: t("collection.labels.details"),
    url: `/collection/console/${consoleId.value}/details`,
  },
]);

async function fetchData() {
  await consoleGet(consoleId.value)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        consoleData.value = data;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function patchData(payload: Partial<ConsoleType>) {
  consolePatch(consoleId.value, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        // emit("update:data");
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

const type = computed(() => route.params.type as string);

// AVATAR
function addAvatar(avatar: string) {
  if (!store.getters.user) return;

  store.commit("SET_LOADING", true);

  avatarAdd(consoleId.value, avatar)
    .then((response) => {
      const { success, message } = response;

      toast({ message: message, type: success ? "success" : "error" });

      emit("update:data");
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function updateAvatar(avatar: string) {
  if (!consoleData.value.avatar) return;

  store.commit("SET_LOADING", true);

  avatarPut(consoleId.value, avatar)
    .then((response) => {
      const { success, message } = response;

      toast({ message: message, type: success ? "success" : "error" });

      emit("update:data");
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function changeAvatar(avatar: string) {
  if (consoleData.value.avatar) {
    updateAvatar(avatar);
  } else {
    addAvatar(avatar);
  }
}

function delAvatar() {
  showAvatarDel.value = true;
}

function delAvatarConfirm() {
  if (!consoleData.value?.avatar) return;

  store.commit("SET_LOADING", true);

  avatarDel(consoleId.value)
    .then((response) => {
      const { success, message } = response;

      toast({ message: message, type: success ? "success" : "error" });

      emit("update:data");
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      showAvatarDel.value = false;
      store.commit("SET_LOADING", false);
    });
}

async function changeMenu(url: string) {
  router.push(url);
}

function back() {
  router.push(`/collection/console`);
}

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(breadcrumbSimple), {
        items: breadcrumbList.value,
        "show-home": true,
        "url-home": "/home",
        active: "edit"
      }, null, 8, ["items"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(svgIcon), {
            icon: "gamepad",
            size: "2rem"
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)("collection.labels.edit_item")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "btn btn-default w-8 h-8",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
          }, [
            _createVNode(_unref(svgIcon), {
              icon: "close",
              size: "1rem"
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(iconMenu), {
          tabs: menuList.value,
          active: "infos",
          size: "3rem",
          onSelected: _cache[1] || (_cache[1] = ($event: any) => (changeMenu($event)))
        }, null, 8, ["tabs"]),
        (consoleData.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_unref(baseAvatar), {
                  position: "center",
                  size: "20rem",
                  "is-edit": true,
                  "show-image": true,
                  url: consoleData.value?.avatar?.large,
                  "aspect-ratio": 1,
                  "border-radius": "0.25rem",
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (changeAvatar($event))),
                  onDel: _cache[3] || (_cache[3] = ($event: any) => (delAvatar()))
                }, null, 8, ["url"])
              ]),
              _createVNode(_unref(FormConsole), {
                data: consoleData.value,
                type: type.value,
                "is-patch": true,
                "onUpdate:data": _cache[4] || (_cache[4] = ($event: any) => (patchData($event)))
              }, null, 8, ["data", "type"]),
              _createVNode(_unref(ListTranslate), {
                "owner-id": consoleId.value,
                language: _unref(locale).toLowerCase(),
                fields: translationFields.value
              }, null, 8, ["owner-id", "language", "fields"]),
              _createVNode(_unref(baseConfirm), {
                show: showAvatarDel.value,
                title: _unref(t)('common.modals.titles.remove_image').toUpperCase(),
                message: _unref(t)('common.modals.messages.remove_image'),
                onCancel: _cache[5] || (_cache[5] = ($event: any) => (showAvatarDel.value = false)),
                onConfirm: _cache[6] || (_cache[6] = ($event: any) => (delAvatarConfirm()))
              }, null, 8, ["show", "title", "message"])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})